import { Injectable } from "@angular/core"; 
import { StorageService } from "../services/storage.service";
import { MsgConfig } from "../app.messages";

@Injectable({
    providedIn: "root"
})
export class ReportsUtil {
    constructor( private _storageService: StorageService) {}
    IsCurrentReportGenerated(report) {
        if (report.ReportName === report.curremtReportName && report.IsReportGenerated) {
            if (report.ReportName === "ViewInventory") {
                return true;
            } else if (report.ReportName === "CallLog") {
                return true;
            } else if (report.ReportName === "ReturnToStock") {
                return true;
            } else if (report.ReportName === "TopPerformers") {
                return true;
            } else if (report.currentRoute.includes(report.ReportName)) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    }
    checkForReportGeneration(report) {
        let sessionAsyncReportId: any =  this._storageService.getSessionStorage(report.ReportName) ? JSON.parse(this._storageService.getSessionStorage(report.ReportName)) : null;
        if (report.AsyncReportId !== sessionAsyncReportId) {
            this._storageService.setSessionStorage(report.ReportName, report.AsyncReportId);
            return true;
        } else {
            return false;
        }
    }
    getReportIsInProgress(res) {
        if(res)
        {
            const message = ("Report " + (res.IsExport ? "Export" : (res.IsPrint ? "Print" : "Preview"))) + " " + MsgConfig.ASYNC_REPORT_HOVEROVER;
            return message;
        }
        else 
            return "";
    }

    /** Default message shown when no report has been generated yet. */
    get initialReportMessage(): string {
        return 'Please click on the "PREVIEW" button to see the report.';
    }

    /**
     * Returns the appropriate "generating" message based on the action type.
     * @param action - 'preview' | 'print' | 'export'
     */
    getGeneratingMessage(action: string): string {
        switch (action) {
            case 'print': return 'Printing your report. This may take a moment...';
            case 'export': return 'Exporting your report. This may take a moment...';
            default: return 'Generating your preview. This may take a moment...';
        }
    }

    /**
     * Determines the action type from the button parameters.
     * @param isPrint - true if the Print button was clicked
     * @param isExport - true if the Export button was clicked
     * @returns 'preview' | 'print' | 'export'
     */
    getActionType(isPrint: boolean, isExport: boolean): string {
        return isExport ? 'export' : (isPrint ? 'print' : 'preview');
    }

    /**
     * Determines the action type from an async report response object.
     * @param res - response from IsAsyncReportExist (has IsPrint, IsExport flags)
     * @returns 'preview' | 'print' | 'export'
     */
    getActionTypeFromResponse(res: any): string {
        return res.IsExport ? 'export' : (res.IsPrint ? 'print' : 'preview');
    }
}
